module.exports = __webpack_public_path__ + "img/0x9f8b20c31bb9e45003f2d9f316d2caf1dcd1bf20.f9354b97.png";